import { apiPost } from "./apiService";

const endpoints = {
  invoice_pipeline: "/invoice-pipeline/",
};

export interface InvoicePipelineRequest {
  supplier: string;
  supplier_invoice_ref: string;
  invoice_received_date: string;
  filename: string;
  file_content_base64: string;
  password?: string;
}

export interface InvoicePipelineOutput {
  bucket: string;
  key: string;
  s3_uri: string;
}

export interface InvoicePipelineLogEntry {
  level: string;
  msg: string;
}

export interface InvoicePipelineSmallBatchResponse {
  mode: "small_batch";
  row_count: number;
  output: InvoicePipelineOutput;
  zoho_response: Record<string, unknown>;
  output_logs: InvoicePipelineLogEntry[];
}

export interface InvoicePipelineBulkResponse {
  mode: "bulk";
  row_count: number;
  output: InvoicePipelineOutput;
  job_id: string;
  bulk_status: string;
  output_logs: InvoicePipelineLogEntry[];
}

export type InvoicePipelineResponse =
  InvoicePipelineSmallBatchResponse | InvoicePipelineBulkResponse;

export const submitInvoicePipeline = (
  payload: InvoicePipelineRequest,
): Promise<InvoicePipelineResponse> =>
  apiPost<InvoicePipelineResponse>(endpoints.invoice_pipeline, payload);

// The file travels as base64 inside the JSON body (API Gateway has no
// multipart support here), so the raw bytes never leave the browser
// un-encoded. Strips the `data:...;base64,` prefix FileReader adds.
export const fileToBase64 = (file: File): Promise<string> =>
  new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () => {
      const result = reader.result as string;
      const commaIndex = result.indexOf(",");
      resolve(commaIndex === -1 ? result : result.slice(commaIndex + 1));
    };
    reader.onerror = () => {
      reject(reader.error ?? new Error("File reading failed"));
    };
    reader.readAsDataURL(file);
  });
